// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"SearchInput_searchIcon__F7Xmh","searchInput":"SearchInput_searchInput__WAXwW"};